import React from 'react';
import styles from './Feature.module.scss';
import {Divider} from "presentation/common";
import {HomeFeatures as features} from "application/globals/home-data";
import {FeatureItem} from "./components/feature-item/FeatureItem";

export const Feature = (props) => {

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>¿Qué podrás realizar aquí?</h1>
      <Divider/>
      <p className={styles.subTitle}>Desde la comodidad de tu hogar podrás solicitar los siguientes servicios para tu vehículo.</p>
      {
        features.map( feature => <FeatureItem label={feature} key={feature}/>)
      }
    </div>
  );
};

Feature.propTypes = {}

Feature.defaultProps = {}

export default React.memo(Feature);
